export const getBreadcrumbs = (pathname, t, getDynamicLabel) => {
  const segments = pathname.split("/").filter(Boolean)
  const breadcrumbs = []

  if (segments.length === 0 || pathname === "/") {
    return [{ label: t("menu.dashboard") || "Dashboard", href: "/dashboard" }]
  }

  // Collapse staff work-history detail routes so the breadcrumb stays human-readable:
  // Staff > {name} > Work history
  if (segments[0] === "staff" && segments[2] === "history" && segments[3]) {
    const staffPath = `/staff/${segments[1]}`
    const staffLabel = getDynamicLabel ? getDynamicLabel(staffPath) : null

    return [
      { label: t("menu.staff") || "Staff", href: "/staff" },
      { label: staffLabel || t("common.detail") || "Detail", href: staffPath },
      { label: t("label.work") || "Work history", href: undefined },
    ]
  }

  // Custom href mappings for paths that don't match the segment
  // e.g., /payroll-data/bonus should redirect to /payroll-data/bonus-list
  const hrefMap = {
    "/payroll-data/bonus": "/payroll-data/bonus-list",
    "/payroll-data/deduction": "/payroll-data/deduction-list",
    "/settings/leave-management/leave-type": "/settings/leave-management",
  }

  let currentPath = ""
  segments.forEach((segment, index) => {
    currentPath += `/${segment}`
    const isLast = index === segments.length - 1

    // Map path segments to labels
    let label = segment.charAt(0).toUpperCase() + segment.slice(1).replace(/-/g, " ")

    // Custom mappings
    const labelMap = {
      dashboard: t("menu.dashboard") || "Dashboard",
      staff: t("menu.staff") || "Staff",
      shift: t("menu.shift") || "Shift",
      create: t("common.create") || "Create",
      edit: t("common.edit") || "Edit",
      detail: t("common.detail") || "Detail",
      list: t("menu.timekeeping_list") || "Timekeeping List",
      timekeeping: t("menu.timekeeping") || "Timekeeping",
      "payroll-data": t("menu.payroll_data") || "Payroll Data",
      "bonus-list": t("menu.bonus") || "Bonus",
      "deduction-list": t("menu.deduction") || "Deduction",
      bonus: t("menu.bonus") || "Bonus",
      deduction: t("menu.deduction") || "Deduction",
      overtime: t("menu.overtime") || "Overtime",
      "leave-request": t("menu.leave_request") || "Leave Request",
      "shift-change": t("menu.shift_change") || "Shift Change",
      "late-early": t("menu.late_early") || "Late/Early",
      settings: t("menu.settings") || "Settings",
      "user-management": t("menu.user_management") || "User Management",
      departments: t("menu.departments") || "Departments",
      "default-system": t("menu.default_system") || "Default System",
      "ai-camera": t("menu.ai_camera") || "AI Camera",
      "leave-management": t("menu.leave_management") || "Leave Management",
      "salary-component": t("menu.salary_component") || "Salary Component",
      "salary-template": t("menu.salary_template") || "Salary Template",
      notifications: t("menu.notifications") || "Notifications",
      report: t("menu.report") || "Report",
      profile: t("menu.profile") || "Profile",
      "change-password": t("menu.change_password") || "Change Password",
      "leave-type": t("menu.leave_type") || "Leave Type",
      "payroll-calculation": t("menu.payroll_calculation") || "Payroll Calculation",
      "payroll-payment": t("menu.payroll_payment") || "Payroll Payment",
      employees: t("menu.employees") || "Employees",
      employee: t("breadcrumb.Employee") || "Employee",
      attendance: t("breadcrumb.Attendance") || "Attendance",
      approval: t("breadcrumb.Approval") || "Approval",
    }

    // Check for dynamic label first (e.g., staff name for detail pages)
    const dynamicLabel = getDynamicLabel ? getDynamicLabel(currentPath) : null

    if (dynamicLabel) {
      label = dynamicLabel
    } else if (!isNaN(segment)) {
      // Skip numeric IDs in breadcrumb labels - show "Detail" as fallback
      label = t("common.detail") || "Detail"
    } else if (labelMap[segment.toLowerCase()]) {
      label = labelMap[segment.toLowerCase()]
    }

    // Keep "Payroll Data" as non-clickable parent on child routes.
    const isPayrollDataParentCrumb =
      segment.toLowerCase() === "payroll-data" && segments.length > 1

    // Determine the href - use mapped href if available, otherwise use currentPath
    const href =
      isLast || isPayrollDataParentCrumb ? undefined : (hrefMap[currentPath] || currentPath)

    breadcrumbs.push({
      label,
      href,
    })
  })

  return breadcrumbs
}
